import { computed } from "vue";
import { useAuthStore } from "@shared/stores/auth";
import { clientId } from "../constants";

const controlledProofRoles = [
  "sds-compliance-officer",
  "sds-policy-administrator",
  "sds-records-manager",
];

function useProductComplianceRoles() {
  return computed(productComplianceRoles);
}

function productComplianceRoles(): string[] {
  const roles: unknown = Object.getOwnPropertyDescriptor(
    useAuthStore().rolesByClientId,
    clientId,
  )?.value?.roles;
  return Array.isArray(roles)
    ? roles.filter((role): role is string => typeof role === "string")
    : [];
}

export function isProductComplianceControlledProofAuthorized() {
  const roles = productComplianceRoles();
  return roles.some((role) => controlledProofRoles.includes(role));
}

export function isProductCompliancePolicyAdministratorAuthorized() {
  const roles = productComplianceRoles();
  return roles.includes("sds-policy-administrator");
}

export function useProductComplianceControlledProofAccess() {
  const roles = useProductComplianceRoles();
  return computed(() =>
    roles.value.some((role) => controlledProofRoles.includes(role)),
  );
}

export function useProductCompliancePolicyAdministrator() {
  const roles = useProductComplianceRoles();
  return computed(() => roles.value.includes("sds-policy-administrator"));
}

export function useProductComplianceOfficer() {
  const roles = useProductComplianceRoles();
  return computed(() => roles.value.includes("sds-compliance-officer"));
}
